export const Buyer_OFFER = [
    {
        type:"text",
        name:"firstName",
        placeholder:"Buyer's first name",
        label : "First Name",
        pattern:/^[a-zA-Z0-9&()\-,'\s]{1,50}$/,
        message:"Invalid Name"
    },
    {
        type:"text",
        name:"lastName",
        placeholder:"Buyer's last name",
        label : "Last Name",
        pattern:/^[a-zA-Z0-9&()\-,'\s]{1,50}$/,
        message:"Invalid Name"
    },
    {
        type:"text",
        name:"emailId",
        placeholder:"Buyer's email",
        label : "Email",
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Invalid Email",
    },
    {
        type:"text",
        name:"phone",
        placeholder:"Buyer's phone #",
        label : "Phone Number",
        pattern: /^[0-9]{10}$/,
        message: "Invalid Phone",
        maxLength:10
    }
]

export const Buyer_Agent_Offer = [
    {
        type:"text",
        name:"firstName",
        placeholder:"Agent's first name",
        label : "First Name",
        pattern:/^[a-zA-Z0-9&()\-,'\s]{1,50}$/,
        message:"Invalid Name"
    },
    {
        type:"text",
        name:"lastName",
        placeholder:"Agent's last name",
        label : "Last Name",
        pattern:/^[a-zA-Z0-9\-&(),'\s]{1,50}$/,
        message:"Invalid Name"
    },{
        type:"text",
        name:"companyName",
        placeholder:"Company Name",
        label : "Company Name",
         pattern:"",
        message:"Invalid Company Name"
    },
    {
        type:"text",
        name:"emailId",
        placeholder:"Enter Email",
        label : "Email",
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Invalid Email",
    },
    {
        type:"text",
        name:"phone",
        placeholder:"Agent's phone #",
        label : "Phone Number",
        pattern: /^[0-9]{10}$/,
        message: "Invalid Phone",
        maxLength:10
    },{
        type:"text",
        name:"licenceNumber",
        placeholder:"Agent's License Number",
        label : "License #",
        pattern: /^[a-zA-Z0-9#.&()',,'\s]{1,}$/,
        message: "Invalid license #",
    },
    {
        type:"date",
        name:"licenseExpirationDateString",
        placeholder:"Enter Expiration Date",
        label : "Expiration Date",
        message:"Invalid Expiration Date"
    },
    {
        type:"select",
        name:"state",
        placeholder:"Select State",
        label : "State",
    },
    
    
]
export const BuyerAgent_Optional =[
   {
        type:"text",
        name:"firstName",
        placeholder:"Agent's first name",
        label : "First Name",
        pattern:/^[a-zA-Z0-9&(),'\s]{1,50}$/,
        message:"Invalid Name"
    },
    {
        type:"text",
        name:"lastName",
        placeholder:"Agent's last name",
        label : "Last Name",
        pattern:/^[a-zA-Z0-9&(),'\s]{1,50}$/,
        message:"Invalid Name"
    },{
        type:"text",
        name:"companyName",
        placeholder:"Company Name",
        label : "Company Name",
         pattern:"",
        message:"Invalid Company Name"
    },
    {
        type:"text",
        name:"emailId",
        placeholder:"Enter Email",
        label : "Email",
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Invalid Email",
    },
    {
        type:"text",
        name:"phone",
        placeholder:"Agent's phone #",
        label : "Phone Number",
        pattern: /^[0-9]{10}$/,
        message: "Invalid Phone",
        maxLength:10
    },
]

export const ClosingAgent = [
    {
        type:"text",
        name:"name",
        placeholder:"Closing Agent Name",
        label: "Agent Name",
         pattern:/^[a-zA-Z0-9&()\-,'\s]{1,50}$/,     
         message:"Invalid Name"
    },
    {
        type:"text",
        name:"companyName",
        placeholder:"Company Name",
        label: "Company Name",
         pattern:"",     
         message:"Invalid Company Name"
    },
    {
        type:"text",
        name:"email",
        placeholder:"Closing Agent Email",
        label: "Email",
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Invalid Email",
    },
    {
        type:"text",
        name:"phone",
        placeholder:"Closing Agent Phone #",
        label: "Phone Number",
        pattern: /^[0-9]{10}$/,
        message: "Invalid Phone",
        maxLength:10
    },

]
export const TitleInsuranceProvider=[
    {
        type:"text",
        name:"name",
        placeholder:"Contact Name",
        label: "Contact Name",
         pattern:/^[a-zA-Z0-9&()\-,'\s]{1,50}$/,     
         message:"Invalid Name"
    },
    {
        type:"text",
        name:"companyName",
        placeholder:"Company Name",
        label: "Company Name",
         pattern:"",     
         message:"Invalid Company Name"
    },
    {
        type:"text",
        name:"email",
        placeholder:"Email",
        label: "Email",
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Invalid Email",
    },
    {
        type:"text",
        name:"phone",
        placeholder:"Phone #",
        label: "Phone Number",
        pattern: /^[0-9]{10}$/,
        message: "Invalid Phone",
        maxLength:10
    },

]